import { Loader } from "components/common/Icons/Loader/Loader";
import { Font } from "../Font/Font";
import { useFontList } from "../useFontList";

type UseFontListReturn = ReturnType<typeof useFontList>;

interface RecentlyUsedFontsProps {
    recentlyUsedFonts: UseFontListReturn["recentlyUsedFonts"];
    isLoadingRecentlyUsedFonts: UseFontListReturn["isLoadingRecentlyUsedFonts"];
    search: UseFontListReturn["search"];
    handleClick: UseFontListReturn["handleClick"];
}

export const RecentlyUsedFonts = ({
    recentlyUsedFonts,
    isLoadingRecentlyUsedFonts,
    search,
    handleClick,
}: RecentlyUsedFontsProps) => {
    return (
        <>
            {recentlyUsedFonts.length > 0 && !isLoadingRecentlyUsedFonts && !search && (
                <>
                    <div className="pl-4 text-sm text-irGray-500 border-t border-t-[#f3f3f3] dark:border-t-darkSurface-400 pt-2 mt-2">
                        Recently Used Fonts
                    </div>
                </>
            )}
            {!search &&
                recentlyUsedFonts.map((font) => (
                    <Font
                        key={font.family}
                        family={font.family}
                        source={font.source}
                        handleClick={handleClick}
                        close={close}
                    />
                ))}
            {isLoadingRecentlyUsedFonts && (
                <div className="flex items-center justify-center py-2">
                    <Loader height={15} width={15} stroke={"var(--dark-gray)"} />
                </div>
            )}
        </>
    );
};
